import { Grid } from "@mui/material";
import FormFields from "./FormFields";

const EmployeeInfoForm = ({
  formData,
  onDataChange,
  onProfilePicChange,
  errors = {},
  isSubmitting = false,
}) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onDataChange(name, value);
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      onProfilePicChange(file);
      // Reset file input
      event.target.value = "";
    }
  };

  return (
    <Grid container spacing={3}>
      <FormFields
        formData={formData}
        handleInputChange={handleInputChange}
        handleFileChange={handleFileChange}
        errors={errors}
        isSubmitting={isSubmitting}
      />
    </Grid>
  );
};

export default EmployeeInfoForm;
